export const formatPrice = (value: number): string => `$${value.toFixed(2)}`;
export const formatDiscount = (value: number): string => `${value}% off`;

type CalculationMethod = 'AMOUNT' | 'PERCENT';

// A POSPricingData bucket can have multiple discounts applied (e.g. a percent-off stacked with a
// dollar-off). Each discount already carries its own PERCENT/AMOUNT calculationMethod (synced from
// leaflogix via Armageddon) -- this picks one to describe the bucket as a whole: majority vote across
// the (already-deduplicated, one-per-distinct-discount) list, ties defaulting to PERCENT. Entries with
// no resolvable calculationMethod are excluded rather than guessed; null if none resolve at all.
export const majorityCalculationMethod = (
  discounts: Array<{ calculationMethod?: CalculationMethod | null }> | null | undefined
): CalculationMethod | null => {
  const tally = { PERCENT: 0, AMOUNT: 0 };
  (discounts ?? []).forEach(({ calculationMethod } = {}) => {
    if (calculationMethod === 'PERCENT' || calculationMethod === 'AMOUNT') tally[calculationMethod] += 1;
  });
  if (tally.PERCENT === 0 && tally.AMOUNT === 0) return null;
  return tally.PERCENT >= tally.AMOUNT ? 'PERCENT' : 'AMOUNT';
};
